import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetCheckoutDisplaySettingsRuleSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/CheckoutDisplaySettingsRule/hooks/useGetCheckoutDisplaySettingsRuleSubheader';

export interface CheckoutDisplaySettingsRuleHeaderProps {
  isActive: boolean;
  isOrderPolicyVisible: boolean;
}

export function CheckoutDisplaySettingsRuleHeader({
  isActive,
  isOrderPolicyVisible,
}: CheckoutDisplaySettingsRuleHeaderProps): JSX.Element {
  const { subheader } = useGetCheckoutDisplaySettingsRuleSubheader({
    isOrderPolicyVisible,
  });
  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Checkout display settings"
      subheader={subheader}
    />
  );
}
